<template>
  <div class="align-center flex justify-center gap-0.5 text-xs">
    <div
      v-if="priority !== -1"
      class="flex items-center rounded-lg bg-lightSecondaryColor px-2 text-black dark:bg-lightTertiaryColor dark:text-white"
    >
      {{ priority + 1 }}
    </div>
    <button class="ml-2 rounded bg-transparent p-1 text-sm font-bold invert">
      <BaseIcon v-if="isInSortingList && isAscending === true" class="max-w-fit" :icon="Icon.SORT_DOWN" />
      <BaseIcon v-else-if="isInSortingList && isAscending === false" class="max-w-fit" :icon="Icon.SORT_UP" />
      <BaseIcon v-else class="max-w-fit" :icon="Icon.SORT" />
    </button>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { Icon } from "../../../../assets/icons/Icon";
import BaseIcon from "../../../../components/BaseIcon.vue";
import { GenericTableSortingItems, SortingDirection } from "../../type.genericTableQuery";
const sorting = defineModel<GenericTableSortingItems>({ required: true });
const props = defineProps<{ field: string }>();

const isAscending = computed(() => {
  for (const sortingItem of sorting.value) {
    if (sortingItem.fieldName === props.field) {
      const isAscending = sortingItem.direction === SortingDirection.ASC ? true : false;
      return isAscending;
    }
  }
});

const isInSortingList = computed(() => {
  return sorting.value.some((sortCondition) => sortCondition.fieldName === props.field);
});

const priority = computed(() => {
  return sorting.value.findIndex((sortCondition) => sortCondition.fieldName === props.field);
});
</script>
